import type { FaireProductEntity } from "../../entity_types/product";

export const p_whaznkuuf3: FaireProductEntity = {
  token: "p_whaznkuuf3",
  type: "product",
  name: "Child of God pouch Christian gift Easter basket makeup bag",
  brandToken: "b_5sfnb3y1",
  brandName: "Aspen Lane",
  imageUrl:
    "https://cdn.faire.com/fastly/58e6872dcd47f528f9562e3a405dc9c36caa35cc580f05b6c2fe4e0d512ef448.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/70296c89e5883276d847aa61b8862660fd7f8a3994232edb41a462488dd749ba.jpeg",
    "https://cdn.faire.com/fastly/77986893d2fcf2922d2e46e4b864360074401f83fd5dca2c0c7e47f249e05cfd.jpeg",
    "https://cdn.faire.com/fastly/96828732df2ecf810597da19ad7333ade45c63463c4c62b6ba2bae72e3275f20.png",
    "https://cdn.faire.com/fastly/fbbc35a6693a11ef13b0de11fa9d75ea5d5986fa20fbdc5eb864fe4d779ccb0d.png",
    "https://cdn.faire.com/fastly/38d2a36375e530b4d39ecfee6164b4f464d3c6cb010c92ee48185cff988519e3.png",
    "https://cdn.faire.com/fastly/e392aa9ce855d592b8a34bb6cae9489d50f47b98d34478da33fb6183e08511f2.png",
    "https://cdn.faire.com/fastly/678081d6636459997ea5674cf2cbf30f7f662916b61e2207024ad482803afaa0.png",
  ],
  priceDollars: 8.5,
  description:
    'Christian gift and faith based gift for that is perfect for inspirational gifts and colorful sections: valentines day gifts, spring Easter baskets, teen gifts, faith based gifting, mom, teen gifts, and more. Pink and white stripe color with Child of Gold in colorful red and pink colorblock. \n\nMaterial is a high quality Tyvek water resistant material. Inside wipeable waterproof lining.\nSize: 9"x6"\n\nAspen Lane Denver, CO and is a female-founded small business that has been in business since 2014.',
  tags: [],
  msrpDollars: 17,
  inStock: false,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:55:01.884Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
